"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealmRunner = void 0;
var realms_utils_1 = require("realms-utils");
var stepPerformanceMonitor_1 = require("./stepPerformanceMonitor");
var RealmRunner = /** @class */ (function () {
    function RealmRunner(realm) {
        this.isRunning = false;
        this.endResolve = null;
        this.fpsMonitor = new realms_utils_1.FPSMonitor(10);
        this.stepPerformanceMonitor = new stepPerformanceMonitor_1.StepPerformanceMonitor(100);
        this.realm = realm;
    }
    // Stops the running realm
    // The realm will only stop running after its current step finishes
    RealmRunner.prototype.end = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.isRunning) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this.endResolve = resolve;
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Queues a method to run after a certain time
     */
    RealmRunner.prototype.queueMethod = function (callback, timeMs) {
        setTimeout(callback, timeMs);
    };
    /**
     * Runs the realm at the given fps. If none is given,
     * it will run as fast as possible
     */
    RealmRunner.prototype.run = function (fps, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onStepEnd = _b.onStepEnd;
        this.isRunning = true;
        var lastTime = this.getSystemTime();
        var step = function () {
            var currTime = _this.getSystemTime();
            var delta = currTime - lastTime;
            // Track the fps
            if (delta > 0) {
                _this.fpsMonitor.addFPS(1000 / delta);
            }
            lastTime = currTime;
            var performance = _this.realm.step(delta);
            _this.stepPerformanceMonitor.addPerformance(performance);
            onStepEnd === null || onStepEnd === void 0 ? void 0 : onStepEnd();
            var timeForStep = _this.getSystemTime() - currTime;
            // Queue next step if no end signal is detected
            if (_this.endResolve === null) {
                var timeoutWaitMs = fps ? Math.max(1000 / fps - timeForStep, 0) : 0;
                _this.queueMethod(step, timeoutWaitMs);
            }
            else {
                _this.isRunning = false;
                _this.endResolve();
                _this.endResolve = null;
            }
        };
        step();
    };
    return RealmRunner;
}());
exports.RealmRunner = RealmRunner;
